import * as React from 'react'
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core'

import { mtc } from '../../../utils/style-helpers'
import { Icon } from '../../atoms/icon'
import { iconTextStyles } from './styles'

export interface IconTextProps extends React.HTMLAttributes<HTMLSpanElement> {
  /** FontAwesome icon to display */
  icon: IconProp | IconDefinition
  /** Text size variant */
  size?: 'xs' | 'sm' | 'md'
  /** Text and icon color (Tailwind class) */
  color?: string
}

export const IconText = React.forwardRef<HTMLSpanElement, IconTextProps>(
  (
    {
      icon,
      size = 'sm',
      color = 'text-neutral-700',
      className,
      children,
      ...props
    },
    ref
  ) => {
    return (
      <span
        ref={ref}
        className={mtc(iconTextStyles({ size }), color, className)}
        {...props}
      >
        <Icon icon={icon} color={color} />
        {children}
      </span>
    )
  }
)

IconText.displayName = 'IconText'
